<template>
  <div class="thankyou-leadfrom">
    <div class='second-step'>
      <div class='left-icon'><span class='icon-container'><i class='icon icon-checked'></i></span></div>
        <div class='icon-right-content'>
          <p class='messsage-title'>{{heading}}</p>
          <p class='info mrgn-20' v-for="dataObj in templateString" >
            <span v-html="dataObj.message" v-if="dataObj.type==='span'"></span>
            <span class="note" v-if="dataObj.type==='note'">
              <span>Note:</span>
              <span v-html="dataObj.message"></span>
            </span>
            <button class='btn btn-primary btn-lg red-button' id='openChatWidgetTemplateButton' v-if="dataObj.type==='button'">{{dataObj.message}}</button>
           </p>
        </div>
    </div>
    <div class="suggestions-yt">
      <p class="heading">Why Travel with us ?</p>

      <ul>
        <li class="col-3">
          <i class="icon icon-best-price"></i>
          <p class="title"> Best Price</p>
          <p class="subtext">A marketplace of suppliers </p>
        </li>
        <li class="col-3">
          <i class="icon icon-customization"></i>
          <p class="title"> Customization</p>
          <p class="subtext">Real time
            <br>end to end customization </p>
        </li>
        <li class="col-3">
          <i class="icon icon-booking-ease"></i>
          <p class="title"> Booking With Ease</p>
          <p class="subtext">Stay in touch with our expert on live chat </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['templateString', 'chatId'],
  data: function() {
    return {
      heading : null
    }      
  },
  methods: {
    closeSlideout: function() {
      this.$emit('closeSlideout')
    }
  },
  created: function() {
    this.heading = this.templateString[0].message
    this.templateString.splice(0,1)
  },
  mounted: function() {
    var vm = this    
    setTimeout(function() {
      if (document.getElementById('openChatWidgetTemplateButton')) {
        document.getElementById('openChatWidgetTemplateButton').addEventListener('click', () => {
          if (document.getElementById('left-head') && document.getElementById('chat-overlay')) {
            vm.$emit('closeSlideout')
            if (window.sso.isUserLoggedIn() && window.angular.element(document.getElementById('chat-overlay')).scope() && vm.chatId) {
              window.angular
                .element(document.getElementById('chat-overlay'))
                .scope()
                .selectContactByChatId(vm.chatId)
            } else {
              document.getElementById('left-head').click()
            }
          }
        })
      }
    }, 3000)
  }
}
</script>

<style lang="scss">
.nested {
  padding-left: 40px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/lead-form/thank-you.vue